export function filterProps(props, allowed) {
  var ret = {};

  for (var key in props) {
    if (allowed[key]) {
      // @ts-ignore
      ret[key] = props[key];
    }
  }

  return ret;
}